import { useTranslation } from 'react-i18next'
import Badge from '../../../components/ui/Badge'

interface Props {
  /** Taslak toplantı sayısı (rozet) — kart yalnız sayaç bilinip > 0 iken çizilir. */
  count: number
  onOpen: () => void
}

/**
 * Toplantılar ekranındaki sabit <b>"Taslaklar"</b> kartı (2026-07-30 analist kararı): grup kartları yalnız
 * yayınlanmış tutanakları temsil eder, taslaklar bu tek karttan (tüm gruplardan) açılır. Karta tıklama
 * Taslaklar listesine gider; oradan detaya girilip tamamlanır ve <b>Yayınla</b> ile ilgili grubun listesine
 * geçer. Grup kartıyla aynı kabuk ({@code mg-card}) — yalnız numara/aksiyon özeti yoktur.
 */
export default function DraftMeetingsCard({ count, onOpen }: Readonly<Props>) {
  const { t } = useTranslation()

  return (
    <div
      className="mg-card mg-card--drafts"
      role="button"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === e.currentTarget) onOpen()
      }}
    >
      <div className="mg-card-head">
        <div className="mg-card-heading">
          <h3 className="mg-card-title">
            <i className="pi pi-file-edit mg-card-icon" aria-hidden="true" />
            {t('meetings.drafts.title')}
          </h3>
        </div>
        <span className="mg-card-count">
          <Badge tone="neutral" variant="soft">
            {t('meetings.card.count', { count })}
          </Badge>
        </span>
      </div>
      <p className="mg-card-desc">{t('meetings.drafts.cardDesc')}</p>
    </div>
  )
}
